<humi-tip>
    <ng-content></ng-content>
</humi-tip>
